<template>
  <div class="d-flex h-100 w-100 justify-content-center">
    <div class="align-self-center">
      <b-btn class="loading-btn-activate"><icon name="spinner" pulse></icon></b-btn>
    </div>
  </div>
</template>
<script>
  export default {
    name: 'activate',
    data () {
      return {}
    },
    mounted () {
      this.onSubmit()
    },
    methods: {
      onSubmit () {
        if (!this.$route.query['token'] || !this.$route.query['username']) {
          this.$notify({
            title: 'ERROR',
            text: 'No activation parameters provided.',
            type: 'error'
          })
          return
        }
        let formData = new FormData()
        formData.append('token', this.$route.query['token'])
        formData.append('username', this.$route.query['username'])
        this.loading = true
        this.$http.post('/api/activate-user', formData)
          .then(res => {
            this.$notify({
              title: 'SUCCESS',
              text: 'Password successfully activated.',
              type: 'success'
            })
            this.loading = false
            setTimeout(() => {
              location.href = '/'
            }, 1000)
          }, res => {
            this.$notify({
              title: 'ERROR',
              text: 'Could not activate.',
              type: 'error'
            })
            this.loading = false
          })
      }
    }
  }
</script>
<style lang="scss">
  .loading-btn-activate .fa-icon {
    width: 7rem;
    height: 7rem;
    color: green;
  }
</style>



// WEBPACK FOOTER //
// src/components/user/Activate.vue